var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"bandeau_col_full"},[_c('p',[_vm._v(" "+_vm._s(_vm.module.modulename)+" - "+_vm._s(_vm.module.itemname)+" ")])]),_c('highcharts',{key:_vm.optionsList.title.text,ref:"highcharts",staticClass:"chart_line_full_col_full",attrs:{"options":_vm.optionsList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }